import { HeadshotProps } from '../Headshot/headshot.types';
import { ImageProps } from '../Image/image.types';
import { LinkProps } from '../Link/link.types';

export enum PlayerMatchupTypes {
  PITCHERPREGAME = 'pitcherPregame',
  PITCHERLIVE = 'pitcherLive',
  PITCHERPOSTGAME = 'pitcherPostgame',
  HITTERLIVE = 'hitterLive',
}

export enum PitchingDecisionTypes {
  W = 'W',
  L = 'L',
  SV = 'SV',
  S = 'S',
}

export enum PlayerMatchupFormats {
  ORIGINAL = 'original',
  VISUAL = 'visual',
  LIST = 'list',
}

export interface PlayerMatchupProps extends Partial<HeadshotProps> {
  type: PlayerMatchupTypes;
  alignment?: 'left' | 'right';
  battingOrder?: number;
  customPlayerInfo?: React.ReactNode | string;
  decision?: PitchingDecisionTypes;
  format?: PlayerMatchupFormats;
  headshotRatio?: ImageProps['ratio'];
  headshotType?: HeadshotProps['type'];
  headshotWidth?: ImageProps['width'];
  headshotZoomScale?: HeadshotProps['zoomScale'];
  jerseyNumber?: number;
  linkProps?: LinkProps;
  name?: string;
  noNameLabel?: string;
  pitchHand?: string; // RHP / LHP / Whats the switch type?
  playerStats?: React.ReactNode | string;
  playerStatsInline?: boolean;
  showHeadShot?: boolean;
  simpleInline?: boolean;
  stacked?: boolean;
  useDecisionBox?: boolean;
  prefix?: React.ReactNode | string;
}
